/**
 * AuthHeader - Simple header for auth pages
 */

import { Building2 } from 'lucide-react'

export default function AuthHeader({ showBack, onBack }) {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-neutral-200">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-brand rounded-lg flex items-center justify-center">
            <Building2 size={18} className="text-white" />
          </div>
          <span className="font-bold text-lg text-ink">Bizos Suite</span>
        </div>
        {showBack && (
          <button onClick={onBack} className="text-sm text-muted hover:text-brand transition-colors">
            ← Back
          </button>
        )}
      </div>
    </header>
  )
}